import { render, staticRenderFns } from "./law-cases-item.vue?vue&type=template&id=eb64d944"
import script from "./law-cases-item.vue?vue&type=script&lang=js"
export * from "./law-cases-item.vue?vue&type=script&lang=js"
import style0 from "./law-cases-item.vue?vue&type=style&index=0&id=eb64d944&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports